import React, {useMemo} from "react";
import {forms, objects} from "@atttomyx/shared-utils";
import {SelectField} from "@atttomyx/react-components";
import {DATE_MODES} from "../../constants";

const AccountSettingsForm = (props) => {
    const { data, onChange : onSync, settingsProps } = props;
    const { dateModes } = settingsProps;

    const datum = useMemo(() => {
        const sanitized = objects.defaultIfNullOrUndefined(data.dateModes, {});

        Object.entries(dateModes).forEach(([key, value]) => {
            sanitized[key] = objects.defaultIfNullOrUndefined(sanitized[key], value);
        });

        return sanitized;
    }, [data, dateModes]);

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);
        const updated = objects.deepCopy(datum);

        updated[field] = value;
        modified.dateModes = updated;
        modified.valid = true;


        onSync(modified);
    };

    return <div className="account-settings-form">
        {Object.entries(dateModes).map(([key, value], index) =>
            <div key={index} className="field">
                <SelectField
                    required={true}
                    label={key}
                    value={forms.sanitizeValue(datum[key])}
                    onChange={(value) => onChange(key, value)}
                    options={DATE_MODES}
                />
            </div>)}
    </div>
};

export default AccountSettingsForm;
